import { Component, Input } from '@angular/core';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';


const MOBILE_MESSAGE_LINE_LIMIT = 22;
@Component({
	selector: 'app-alert-label',
	templateUrl: './alert-label.component.html',
	styleUrls: ['./alert-label.component.scss']
})
export class AlertLabelComponent {
	@Input() text;

	@Input() isMobile = false;
	
	message = '';
	messageSecondPart = '';
	
	constructor(private ibeAdminService: INDRAIbeAdminService) {
	}
	
	ngOnInit(): void {
		
		try { 
			if (this.text) { 
				const translatedText = this.ibeAdminService.getTranslationValue(`availability.flightsPage.text.${this.INDRA_print(this.text)}`);

				if (translatedText) { 

					const buffer = translatedText.split(' ');
					if (this.isMobile && translatedText.length > MOBILE_MESSAGE_LINE_LIMIT) {
						buffer.forEach(wordPiece => {
							if (!this.messageSecondPart && (this.message.length + wordPiece.length < MOBILE_MESSAGE_LINE_LIMIT)) {
								this.message += wordPiece + ' ';
							} else {
								this.messageSecondPart += wordPiece + ' ';

							}
						});
					} else {
						this.message = translatedText;
					}
				}
			}
		} catch (error) {
			console.error(`Error Translating availability.flightsPage.text.${this.text}`, error);
		}
		
		
	}



	INDRA_print(desc) {
		if (desc) return desc.replace(/[!.\s]/g, '').toLowerCase();
	}
}
